import React, { useEffect, useMemo, useState } from "react"
import Web3 from "web3";
import { Fa2Modal, Auth, Forms, Links, notify } from "@housebets/housebets-x-package"
import {CodeInput} from '@housebets/housebets-x-package/lib/components/form/CodeInput';
import { ILinkProps } from "@housebets/housebets-x-package/lib/components/feature/lists/SocialLinks/Button/types";
import {useAppSelector} from "hooks/useAppSelector";
import apiAuth from "app/api/auth";
import { loginSuccess } from "app/store/slices/user";
import { setLoginType } from "app/store/slices/setting";
import { LoginType } from "app/types/common";
import { useWindowSize } from "app/utils/hooks/useWindowSize";
import { useGTMEvents } from "app/hooks/useGTMEvents";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import {TFormikConfig} from "./types";
import {FormikProps, useFormik} from "formik";
import { open2FaModal } from "app/store/slices/user";
import { close2FaModal } from "app/store/slices/user";
import { setData2Fa } from "app/store/slices/user";
import * as Yup from "yup";

let web3: Web3 | undefined; // Will hold the web3 instance

const initData = {
    twoFaCode: "",
};

export const Fa2Auth: React.FC = () => {
    const {isMobile} = useWindowSize();
    const dispatch = useDispatch();
    const {form, registration} = useGTMEvents();
    const affilkaTag = useAppSelector((state) => state.setting.affilkaTag);
    const promoCode = useAppSelector((state) => state.setting.promoCode);
    const inviteCode = useAppSelector((state) => state.setting.inviteCode);

    const {$t} = useIntl();

    const formSchema = () =>
        Yup.object().shape({
            twoFaCode: Yup.string()
                .required($t({id: "FieldIsRequired"}))
                .length(6),
        });

    const isOpen2FaModal = useAppSelector((state) => state.user.isOpen2FaModal);
    const isData2Fa = useAppSelector((state) => state.user.is2FaData);
    const isType2Fa = useAppSelector((state) => state.user.is2FaType);

    useEffect(() => {
        console.log('isOpen2FaModal,' ,isOpen2FaModal )
    }, [isOpen2FaModal])

    const [isDisabled, setIsDisabled] = useState(false);

    const formik: FormikProps<TFormikConfig> = useFormik<TFormikConfig>({
        initialValues: {...initData},
        validationSchema: formSchema(),
        validateOnBlur: false,
        validateOnChange: true,
        onSubmit: async (data) => {
            setIsDisabled(true);
            if (isType2Fa === "metaMaskLogin") {
                handleLoginByMetaMask({
                    ...isData2Fa,
                    twoFaCode: data.twoFaCode,
                });
            } else if (isType2Fa === "googleLogin") {
                handleLoginGoogle({
                    ...isData2Fa,
                    twoFaCode: data.twoFaCode,
                });
            } else if (isType2Fa === "tgLogin") {
                handleLoginTg({
                    ...isData2Fa,
                    twoFaCode: data.twoFaCode,
                });
            }
        },
    });

    const handleLoginTg = async (data: any) => {
        const res = await apiAuth.tgLogin(data);
        setIsDisabled(false);
        if (res.data.code === 13) {
            dispatch(open2FaModal());
            return;
        }
        if (res.status === 200 && res.data.code === 0) {
            dispatch(close2FaModal());
            dispatch(loginSuccess(res.data.data));
            dispatch(setLoginType(LoginType.HIDE));
            registration.complete({
                affiliate_code: affilkaTag ? affilkaTag : "-1",
                bonus_code: "",
                currency: res.data.data.userMoneyType,
                marketing_opt_in: false,
                promo_code: promoCode?.toString() || "",
                registration_method: "telegram",
                signup_source: window.location.pathname,
                user_id: res.data.data.userId,
                user_type: "regular",
            });
            return;
        }
        if (res.data.code === 101) {
            notify({
                type: "error",
                title: "SystemError",
            });
            return;
        }
        notify({
            type: "error",
            title: $t({id: `Google_LOGIN_ERROR_${res.data.code}`}),
        });
    };

    const handleLoginByMetaMask = async (data: any) => {
        const res = await apiAuth.metaMaskLogin(data);
        setIsDisabled(false);

        if (res.data.code === 13) {
            dispatch(open2FaModal());
            return;
        }

        if (res.status === 200 && res.data.code === 0) {
            dispatch(loginSuccess(res.data.data));
            dispatch(close2FaModal());
            if (res.data.data.eventType === 0) {
                registration.complete({
                    affiliate_code: affilkaTag ? affilkaTag : "-1",
                    bonus_code: "",
                    currency: res.data.data.userMoneyType,
                    marketing_opt_in: false,
                    promo_code: promoCode?.toString() || "",
                    registration_method: "metamask",
                    signup_source: window.location.pathname,
                    user_id: res.data.data.userId,
                    user_type: "regular",
                });
            } else {
                form.event({
                    event: "form_submit",
                    form_id: "signin_form",
                    form_name: "Sign In Form",
                });
            }
            // showLiveChat();
            dispatch(setLoginType(LoginType.HIDE));
            return;
        }
        if (res.data.code === 101) {
            notify({
                type: "error",
                title: "SystemError",
            });
            return;
        }
        notify({
            type: "error",
            title: $t({id: `Google_LOGIN_ERROR_${res.data.code}`}),
        });
    };

    const handleLoginGoogle = async (data: any) => {
        const res = await apiAuth.googleLogin(data);
        setIsDisabled(false);

        if (res.status === 200 && res.data.code === 0) {
            dispatch(close2FaModal());
            dispatch(loginSuccess(res.data.data));
            dispatch(setLoginType(LoginType.HIDE));
            if (res.data.data.eventType === 0) {
                registration.complete({
                    affiliate_code: affilkaTag ? affilkaTag : "-1",
                    bonus_code: "",
                    currency: res.data.data.userMoneyType,
                    marketing_opt_in: false,
                    promo_code: promoCode?.toString() || "",
                    registration_method: "google",
                    signup_source: window.location.pathname,
                    user_id: res.data.data.userId,
                    user_type: "regular",
                });
            } else {
                form.event({
                    event: "form_submit",
                    form_id: "signin_form",
                    form_name: "Sign In Form",
                });
            }
            // showLiveChat();
            return;
        }
        notify({
            type: "error",
            title: $t({id: `Google_LOGIN_ERROR_${res.data.code}`}),
        });
    };

    return (
        <>
            <Fa2Modal isOpen={isOpen2FaModal} onClose={() => dispatch(close2FaModal())}>
                <form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                    <Auth.Form.Row>
                        <Auth.Form.FormTitle>{$t({id: "TwoFactorAuthForm.verification"})}</Auth.Form.FormTitle>
                        <Auth.Form.FormSubTitle>{$t({id: 'TwoFactorAuthForm.enterCode'})}</Auth.Form.FormSubTitle>
                    </Auth.Form.Row>
                    <Auth.Form.Row>
                        <CodeInput
                            name="twoFaCode"
                            inputMode="numeric"
                            type="number"
                            label=""
                            disabled={isDisabled}
                            fields={6}
                            value={formik.values.twoFaCode}
                            error={
                                formik?.errors?.twoFaCode
                                    ? {
                                          message: "",
                                      }
                                    : null
                            }
                            touch={() =>
                                formik.setTouched({
                                    twoFaCode: true,
                                })
                            }
                            untouch={() =>
                                formik.setTouched({
                                    twoFaCode: false,
                                })
                            }
                            onChange={(v) => {
                                formik.setFieldValue("twoFaCode", String(v));
                                formik.setFieldTouched("twoFaCode", true, false);
                                setTimeout(() => {
                                    formik.validateField("twoFaCode");
                                });
                            }}
                        />
                    </Auth.Form.Row>
                    <Forms.TFA.Row padding>
                        <Forms.TFA.Button disabled={isDisabled} type="submit" text={$t({id: "Verify"})} />
                    </Forms.TFA.Row>
                </form>
            </Fa2Modal>
        </>
    );
};

Fa2Auth.displayName = "Fa2Auth";
